import { createFileRoute } from "@tanstack/react-router";
import DepartmentsSection from "@/features/settings/components/departments-section";
import { useCurrentOrg, useIsOrgAdmin } from "@/stores";

function SettingsDepartmentsRoute() {
  const org = useCurrentOrg();
  const canEdit = useIsOrgAdmin();
  if (!org) return null;
  return <DepartmentsSection orgId={org.id} canEdit={canEdit} />;
}

export const Route = createFileRoute("/_admin/settings/departments")({
  component: SettingsDepartmentsRoute,
});
